export default "__VITE_ASSET__CapMknQL__"